"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// PLEASE KEEP IN ALPHABETICAL ORDER. This helps with visually finding entries, knowing where to put
// new ones, and merge conflicts.
var ParameterId;
(function (ParameterId) {
    ParameterId["ActiveTablesInfo"] = "active-tables-info";
    ParameterId["AnchorDate"] = "anchor-date";
    ParameterId["AnnotateEnum"] = "annotate-enum";
    ParameterId["AnnotationList"] = "annotation-list";
    ParameterId["ApplyWorksheetFormatting"] = "apply-worksheet-formatting";
    ParameterId["CategoricalDomain"] = "categorical-domain";
    ParameterId["ClickThroughEnabled"] = "click-through-enabled";
    ParameterId["Columns"] = "columns";
    ParameterId["ColumnsToInclude"] = "columns-to-include";
    ParameterId["ColumnsToIncludeById"] = "columns-to-include-by-id";
    ParameterId["ConnectionDescriptionSummaries"] = "connection-description-summaries";
    ParameterId["CurrentSheetType"] = "current-sheet-type";
    ParameterId["CustomView"] = "custom-view";
    ParameterId["CustomViewIsDefault"] = "custom-view-is-default";
    ParameterId["CustomViewIsPublic"] = "custom-view-is-public";
    ParameterId["CustomViewLuid"] = "custom-view-luid";
    ParameterId["CustomViewName"] = "custom-view-name";
    ParameterId["CustomViews"] = "custom-views";
    ParameterId["Dashboard"] = "dashboard";
    ParameterId["DashboardFilters"] = "dashboard-filters";
    ParameterId["DashboardName"] = "dashboard";
    ParameterId["DashboardObjectPositionAndSizeUpdate"] = "dashboard-object-position-and-size-update";
    ParameterId["DashboardObjectPositionAndSizeUpdateList"] = "dashboard-object-position-and-size-update-list";
    ParameterId["DataRowIndex"] = "data-row-index";
    ParameterId["DataSchema"] = "data-schema";
    ParameterId["DataSource"] = "data-source";
    ParameterId["DataSourceDataTable"] = "data-source-data-table";
    ParameterId["DataSourceId"] = "data-source-id";
    ParameterId["DataSourceName"] = "data-source-name";
    ParameterId["DataTable"] = "data-table";
    ParameterId["DataTableReader"] = "data-table-reader";
    ParameterId["DateRangeType"] = "date-range-type";
    ParameterId["DeleteCount"] = "delete-count";
    ParameterId["DeltaTimeMs"] = "delta-time-ms";
    ParameterId["DimValSelectionModels"] = "dimensionValueSelectionModels";
    ParameterId["DomainType"] = "domain-type";
    ParameterId["EmbeddingAbstractQuery"] = "embedding-abstract-query";
    ParameterId["EmbeddingBootstrapInfo"] = "embedding-bootstrap-info";
    ParameterId["EncodingType"] = "encoding-type";
    ParameterId["ExportCrosstabSheetMap"] = "export-crosstab-sheet-map";
    ParameterId["ExportFile"] = "export-file";
    ParameterId["ExportOriginUrl"] = "export-origin-url";
    ParameterId["ExportPdfOptions"] = "export-pdf-options";
    ParameterId["ExtensionBootstrapInfo"] = "extension-bootstrap-info";
    ParameterId["ExtensionContextMenuIds"] = "extension-context-menu-ids";
    ParameterId["ExtensionDialogH"] = "extension-dialog-height";
    ParameterId["ExtensionDialogMessage"] = "extension-dialog-message";
    ParameterId["ExtensionDialogPayload"] = "extension-dialog-payload";
    ParameterId["ExtensionDialogResult"] = "extension-dialog-result";
    ParameterId["ExtensionDialogStyle"] = "extension-dialog-style";
    ParameterId["ExtensionDialogUrl"] = "extension-dialog-url";
    ParameterId["ExtensionDialogW"] = "extension-dialog-width";
    ParameterId["ExtensionLocator"] = "extension-locator";
    ParameterId["ExtensionSettingsInfo"] = "extension-settings-info";
    ParameterId["ExtensionZoneId"] = "extension-zone-id";
    ParameterId["ExternalMenuDescription"] = "external-menu-description";
    ParameterId["ExternalMenuHeader"] = "external-menu-header";
    ParameterId["ExternalMenuItemDisplayName"] = "external-menu-item-display-name";
    ParameterId["ExternalMenuItemId"] = "external-menu-item-id";
    ParameterId["Field"] = "field";
    ParameterId["FieldCount"] = "field-count";
    ParameterId["FieldId"] = "field-id";
    ParameterId["FieldName"] = "field-name";
    ParameterId["FilterLevels"] = "filter-levels";
    ParameterId["FilterRangeMax"] = "filter-range-max";
    ParameterId["FilterRangeMin"] = "filter-range-min";
    ParameterId["FilterRangeNullOption"] = "filter-range-null-option";
    ParameterId["FilterUpdateType"] = "filter-update-type";
    ParameterId["FilterValues"] = "filter-values";
    ParameterId["FontNameListItems"] = "font-name-list-items";
    ParameterId["FormattedText"] = "formatted-text";
    ParameterId["FunctionName"] = "function-name";
    ParameterId["FromIndex"] = "from-index";
    ParameterId["HierValSelectionModels"] = "hierarchicalValueSelectionModels";
    ParameterId["HighlightedData"] = "highlighted-data";
    ParameterId["HoverTupleInteraction"] = "hover-tuple-interaction";
    ParameterId["IgnoreAliases"] = "ignore-aliases";
    ParameterId["IgnoreSelection"] = "ignore-selection";
    ParameterId["IncludeAllColumns"] = "include-all-columns";
    ParameterId["InvalidAggFieldName"] = "invalid-agg-field-name";
    ParameterId["InvalidDates"] = "invalid-dates";
    ParameterId["InvalidFieldCaption"] = "invalid-field-caption";
    ParameterId["InvalidFields"] = "invalid-fields";
    ParameterId["InvalidValues"] = "invalid-values";
    ParameterId["IsAnalyticsAssistantAvailable"] = "is-analytics-assistant-available";
    ParameterId["IsExcludeMode"] = "is-exclude";
    ParameterId["IsExtensionDialog"] = "is-extension-dialog";
    ParameterId["IsFromCalcDialog"] = "is-from-calc-dialog";
    ParameterId["JoinDescription"] = "join-description";
    ParameterId["LogicalTableId"] = "logical-table-id";
    ParameterId["LogicalTableInfoList"] = "logical-table-info-list";
    ParameterId["MarksCardIndex"] = "marks-card-index";
    ParameterId["MaxHeight"] = "max-height";
    ParameterId["MaxRows"] = "max-rows";
    ParameterId["MaxWidth"] = "max-width";
    ParameterId["MinHeight"] = "min-height";
    ParameterId["MinWidth"] = "min-width";
    ParameterId["PageRowCount"] = "page-row-count";
    ParameterId["ParameterCaption"] = "paremeter-caption";
    ParameterId["ParameterError"] = "parameter-error";
    ParameterId["ParameterFieldName"] = "parameter-field-name";
    ParameterId["ParameterInfo"] = "parameter-info";
    ParameterId["ParameterInfos"] = "parameter-infos";
    ParameterId["ParameterValue"] = "parameter-value";
    ParameterId["PeriodType"] = "period-type";
    ParameterId["PulseFieldName"] = "fieldName";
    ParameterId["PulseFieldNames"] = "fieldNames";
    ParameterId["PulseFilterDomainType"] = "domainType";
    ParameterId["PulseFilterDomainSearchTerm"] = "searchTerm";
    ParameterId["PulsePageSize"] = "pageSize";
    ParameterId["PulseNextPageToken"] = "nextPageToken";
    ParameterId["PulseFilters"] = "filters";
    ParameterId["PulseTimeDimension"] = "timeDimension";
    ParameterId["QuantitativeDomain"] = "quantitative-dmain";
    ParameterId["QuantRangeSelectionModels"] = "quantativeRangeSelectionModels";
    ParameterId["RangeN"] = "range-n";
    ParameterId["ReplaySpeed"] = "replay-speed";
    ParameterId["SelectedData"] = "selected-data";
    ParameterId["SelectedSheetNames"] = "selected-sheet-names";
    ParameterId["Selection"] = "selection";
    ParameterId["SelectionList"] = "selection-list";
    ParameterId["SelectionUpdateType"] = "selectionUpdateType";
    ParameterId["SelectTuplesInteraction"] = "select-tuples-interaction";
    ParameterId["SendNotifications"] = "send-notifications";
    ParameterId["SettingsValues"] = "settings-values";
    ParameterId["SharedFilterSheets"] = "shared-filter-sheets";
    ParameterId["SharedFiltersInfo"] = "shared-filters-info";
    ParameterId["SheetIdentifier"] = "sheet-identifier";
    ParameterId["SheetName"] = "sheet-name";
    ParameterId["SheetPath"] = "sheet-path";
    ParameterId["ShouldRefreshDS"] = "should-refresh-ds";
    ParameterId["ShowDataTableFormat"] = "show-data-table-format";
    ParameterId["StartIndex"] = "start-index";
    ParameterId["State"] = "state";
    ParameterId["StoryPointIndex"] = "story-point-index";
    ParameterId["StoryPointInfo"] = "story-point-info";
    ParameterId["SwitchToSheetName"] = "switch-to-sheet-name";
    ParameterId["TargetPoint"] = "target-point";
    ParameterId["TestConversionParameter"] = "test-conversion-parameter";
    ParameterId["Text"] = "formatted-text";
    ParameterId["ToIndex"] = "to-index";
    ParameterId["TooltipContext"] = "tooltip-context";
    ParameterId["TooltipTextRequest"] = "tooltip-text-request";
    ParameterId["TooltipText"] = "tooltip-text";
    ParameterId["UnderlyingDataTable"] = "underlying-data-table";
    ParameterId["UnderlyingSummaryDataTable"] = "underlying-summary-data-table";
    ParameterId["Url"] = "url";
    ParameterId["UseTabDelimiters"] = "use-tab-delimiters";
    ParameterId["ViewDataTableCacheId"] = "view-data-table-cache-id";
    ParameterId["ViewDataTableId"] = "view-data-table-id";
    ParameterId["VisualId"] = "visual-id";
    ParameterId["VisualSpecification"] = "visual-specification";
    ParameterId["VizAPIInputJson"] = "vizapi-input-json";
    ParameterId["VizAPIStateWithDataModel"] = "vizapi-state-with-data-model";
    ParameterId["VizAPIStateWarningMsg"] = "vizapi-state-warning-msg";
    ParameterId["VizAPISVG"] = "vizapi-svg";
    ParameterId["WorksheetName"] = "worksheet-name";
    ParameterId["WorksheetFilters"] = "worksheet-filters";
    ParameterId["ZoneIdsVisibilityMap"] = "zone-ids-visibility-map";
})(ParameterId = exports.ParameterId || (exports.ParameterId = {}));
//# sourceMappingURL=Parameters.js.map